import React, { useState } from "react";
import { useGetProjectDetails } from "../../../../../queries/query-hooks/workspace/workspace-hook";
import { useParams } from "react-router-dom";
import ReactTable from "../../../../../lib/table/react-table";
import { Button } from "react-bootstrap";
import { findIcon } from "../../../../dashboard/icons";
import { useGetContentInfo } from "../../../../../queries/query-hooks/workspace/sponsored-community-hook";
import dayjs from "dayjs";
import CommonTableLoader from "../../../../../skeleton/common-table-loader";
import useRedirect from "../../../../../components/custom-hooks/use-redirect";
import { getContentIcon } from "../utils/commonFunctions";
import { Swiper, SwiperSlide } from "swiper/react";
import { fallbackImages } from "../../../../../common/constants/fallback-images";
import { ProjectHeaderTopBar, TextAndDateFilter } from "@ui";

const Content = () => {
  const { project_id } = useParams();
  const [currentPageNumber, setCurrentPageNumber] = useState(0);
  const { data: projectDetails, isLoading: isProjectDetailsLoading } =
    useGetProjectDetails(project_id, true);
  const [dateRangePayload, setDateRangePayload] = useState({
    start_date: "",
    end_date: "",
  });
  const [searchInputText, setSearchInputText] = useState("");
  const [filterText, setFilterText] = useState("");
  const [offSet, setOffSet] = useState(0);
  const { redirectTo } = useRedirect();

  const { data: contentsListData, isLoading: isContentsListLoading } =
    useGetContentInfo(
      project_id,
      {
        from: 0,
        to: 10,
        filter: [
          {
            type: "content",
            query: filterText,
            start_date: dateRangePayload.start_date,
            end_date: dateRangePayload.end_date,
            content_id: "",
            limit: 10,
            offset: offSet,
          },
        ],
      },
      !!dateRangePayload.start_date && !!dateRangePayload.end_date
    );

  const contentsList = contentsListData?.rows ?? [];
  const totalCount = contentsListData?.totalCount ?? 0;

  const LOCATION_REPORT_TABLE_COLUMNS = [
    {
      columnId: 1,
      Header: "Content Title",
      accessor: "title",
      disableFilters: true,
      disableSortBy: false,
      Cell: ({ row }) => {
        return (
          <div className="d-flex align-items-center gap-3">
            <div className="col-md-4">
              <img
                src={row?.original?.thumbnail}
                alt={"content-image"}
                width={"100%"}
                height={"100%"}
                className="object-fit-contain rounded-3"
                onError={(e) => (e.target.src = fallbackImages.noImage)}
              />
            </div>
            <div className="col-md-8">
              <div>
                <Swiper
                  as="ul"
                  className="p-0 m-0 mb-2"
                  slidesPerView="auto"
                  spaceBetween={10}
                  data-aos="fade-up"
                  data-aos-delay="700"
                >
                  <SwiperSlide key={`content-type-1`} style={{ width: "auto" }}>
                    {row?.original?.type && (
                      <span className="text-primary fs-7 bg-light badge bg-opacity-25 rounded-pill text-nowrap">
                        <span className="me-1">
                          {getContentIcon(row?.original?.type)}
                        </span>
                        <span className="fs-7 text-capitalize">
                          {row?.original?.type}
                        </span>
                      </span>
                    )}
                  </SwiperSlide>
                  {row?.original?.specialities?.length > 0 && (
                    <SwiperSlide
                      key={`content-specialities-2`}
                      style={{ width: "auto" }}
                    >
                      {row?.original?.specialities?.map((speciality, index) => (
                        <span
                          key={`speciality-${index}`}
                          className="text-primary fs-7 bg-light rounded-pill badge bg-opacity-25 text-nowrap me-1 text-capitalize"
                        >
                          {speciality}
                        </span>
                      ))}
                    </SwiperSlide>
                  )}
                </Swiper>
              </div>
              <p className="fw-semibold fs-6">{row?.original?.title}</p>
            </div>
          </div>
        );
      },
    },
    {
      columnId: 2,
      Header: "Date",
      accessor: "published_at",
      disableFilters: true,
      disableSortBy: false,
      Cell: (value) => {
        if (!value.value) return "---";
        return (
          <div className="text-nowrap">
            <p className="mb-1">{dayjs(value.value).format("MMM DD, YYYY")}</p>
            <p className="m-0 text-muted fs-7">Published</p>
          </div>
        );
      },
    },
    {
      columnId: 3,
      Header: "Content Type",
      accessor: "type",
      disableFilters: true,
      disableSortBy: false,
      Cell: (value) => {
        if (!value.value) return "---";
        return <p className="text-capitalize">{value.value}</p>;
      },
    },
    {
      columnId: 4,
      Header: "Views",
      accessor: "views",
      disableFilters: true,
      disableSortBy: false,
      Cell: (value) => {
        return value.value || 0;
      },
    },
    {
      columnId: 5,
      Header: "Reads",
      accessor: "reads",
      disableFilters: true,
      disableSortBy: false,
      Cell: (value) => {
        return value.value || 0;
      },
    },
    {
      columnId: 6,
      Header: "Likes",
      accessor: "total_likes",
      disableFilters: true,
      disableSortBy: false,
      Cell: (value) => {
        return value.value || 0;
      },
    },
    {
      columnId: 7,
      Header: "Comments",
      accessor: "total_comments",
      disableFilters: true,
      disableSortBy: false,
      Cell: (value) => {
        return value.value || 0;
      },
    },
    {
      columnId: 8,
      Header: "Action",
      accessor: "action",
      disableFilters: true,
      disableSortBy: true,
      Cell: ({ row }) => {
        const contentId = row?.original?.content_id;
        const contentType = row?.original?.type?.toLowerCase();
        return (
          <div className="d-flex justify-content-center align-items-center gap-3">
            <Button
              className="btn btn-sm rounded-pill border-0"
              onClick={() => window.open(row?.original?.deeplink, "_blank")}
              style={{ backgroundColor: "#3256B81A", color: "#3256B8" }}
            >
              {findIcon("Eye", "solid", 14)}
            </Button>
            <Button
              className="btn btn-sm rounded-pill border-0"
              onClick={() =>
                redirectTo(
                  `sponsored-community/content-analytics/${contentType}/${contentId}/${project_id}`
                )
              }
              style={{ backgroundColor: "#159A6C1A", color: "#159A6C" }}
            >
              {findIcon("content_analytics", "outline", 14)}
            </Button>
          </div>
        );
      },
    },
  ];

  const onSearchFilterTextHanlder = (e) => {
    if (e.key === "Enter") setFilterText(searchInputText);
  };

  const onTableStateChange = (e) => {
    setCurrentPageNumber(e?.pageIndex);
    setOffSet(e?.pageIndex * 10);
  };

  return (
    <div>
      <div>
        <ProjectHeaderTopBar
          projectType="CLIRNET Channel"
          title="Content"
          projectStartDate={projectDetails?.at(0)?.project_start_date || ""}
          projectEndDate={projectDetails?.at(0)?.project_end_date || ""}
          status={projectDetails?.at(0)?.project_status}
          isProjectDetailsLoading={isProjectDetailsLoading}
        />
      </div>

      <TextAndDateFilter
        searchText="Search Content"
        filterText="Filter Analytics by Date"
        searchInputText={searchInputText}
        setSearchInputText={setSearchInputText}
        onSearchFilterTextHanlder={onSearchFilterTextHanlder}
        setDateRangePayload={setDateRangePayload}
        dateLabel={dateRangePayload}
      />

      <div className="mb-3">
        {!isContentsListLoading ? (
          <ReactTable
            data={Array.isArray(contentsList) ? contentsList : []}
            columns={LOCATION_REPORT_TABLE_COLUMNS}
            recordsTotal={totalCount}
            isPaginationShow={
              Array.isArray(contentsList) && contentsList?.length > 0
                ? true
                : false
            }
            recordsPerPage={10}
            currentPageNumber={currentPageNumber}
            borderBottom
            noDataText="No Data Available"
            onTableStateChange={onTableStateChange}
          />
        ) : (
          <CommonTableLoader
            tableRowLength={5}
            hasSearch={false}
            hasActions={false}
          />
        )}
      </div>
    </div>
  );
};

export default Content;
